import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee-attendance",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Batch Employed Trainees")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee-attendance",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row w-100 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_8 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "font-weight-normal" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "font-weight-normal" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "font-weight-normal" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "On job duration calculation rule: if joining date is before assessment date, duration will be calculated based on assessment date. Otherwise duration will be calculated based on joining date(which will be after assessment date).", -1)
const _hoisted_27 = { class: "card-body border-top p-6" }
const _hoisted_28 = { class: "table-responsive mt-3" }
const _hoisted_29 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", { class: "sticky-header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-25px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " SL "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-250px text-left align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Photo "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "w-50px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Ref. No. "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-140px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Reg. No. "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Trainee Name "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Designation "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      colspan: "3"
    }, " Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      colspan: "2"
    }, " Employment Duration "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Mobile "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Employment Type "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Current Employment Status "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Assessment Date "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "min-w-120px text-center align-middle border border-gray-400 sticky-header",
      rowspan: "2"
    }, " Monthly Income (BDT) ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-dark border border-gray-400" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Name "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Address "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Country "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " From "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " To ")
  ])
], -1)
const _hoisted_31 = { style: {} }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, " Bangladesh ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, " 1 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                title: "Download Xlse",
                "data-v-54b12dc8": "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTrainee()))
              }, _hoisted_10),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                title: "Download PDF",
                "data-v-54b12dc8": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
              }, _hoisted_12),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                title: "Print",
                "data-v-54b12dc8": "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printPdf()))
              }, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.entity_name), 1),
            _hoisted_17,
            _createElementVNode("h4", _hoisted_18, [
              _createTextVNode(" Instittute Name : "),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.institute_name) + ", " + _toDisplayString(_ctx.institute_district), 1)
            ]),
            _hoisted_20,
            _createElementVNode("h4", _hoisted_21, [
              _createTextVNode(" Course Name : "),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.course_name), 1)
            ]),
            _createElementVNode("h4", _hoisted_23, [
              _createTextVNode(" Batch # "),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.batch_number), 1)
            ]),
            _createElementVNode("p", _hoisted_25, "( Total : " + _toDisplayString(_ctx.total_trainee) + ", Female: " + _toDisplayString(_ctx.female_trainee) + ")", 1),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("table", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("tbody", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (data, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: "border border-gray-400 text-center"
                    }, [
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("img", {
                          src: 
                                _ctx.api_url + data?.attach_file_info?.file_path
                              ,
                          alt: "",
                          width: "32",
                          height: "32"
                        }, null, 8, _hoisted_32)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(data?.reference_number), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.registration_number), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_name), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_employment[0]?.designation), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_employment[0]?.organization_name), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_employment[0]?.organization_address), 1),
                      _hoisted_33,
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_employment[0]?.joining_date?_ctx.moment(data?.trainee_employment[0]?.joining_date).format("DD-MM-YYYY"):""), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_employment[0]?.release_date?_ctx.moment(data?.trainee_employment[0]?.release_date).format("DD-MM-YYYY"):"Till Now"), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.mobile), 1),
                      _createElementVNode("td", null, [
                        (data?.trainee_employment[0]?.employment_type == 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Self Employment")
                            ], 64))
                          : _createCommentVNode("", true),
                        (data?.trainee_employment[0]?.employment_type == 2)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Wages Employment")
                            ], 64))
                          : _createCommentVNode("", true),
                        (data?.trainee_employment[0]?.employment_type == 3)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode("Upskill Employment")
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_34,
                      _createElementVNode("td", null, _toDisplayString(data?.training_assessment?.assessment_date?_ctx.moment(data?.training_assessment?.assessment_date).format("DD-MM-YYYY"):""), 1),
                      _createElementVNode("td", null, _toDisplayString(data?.trainee_employment[0]?.salary), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}